var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "#6C737F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 14.3162C17.9988 13.73 18.5938 12.7675 18.5938 11.875C18.5938 9.8975 17.0625 8.375 15.0938 8.375H9.625V20.625H15.785C17.6137 20.625 19.0312 19.1375 19.0312 17.3088C19.0312 15.9788 18.2788 14.8412 17.15 14.3162ZM12.25 10.5625H14.875C15.6013 10.5625 16.1875 11.1488 16.1875 11.875C16.1875 12.6013 15.6013 13.1875 14.875 13.1875H12.25V10.5625ZM15.3125 18.4375H12.25V15.8125H15.3125C16.0388 15.8125 16.625 16.3988 16.625 17.125C16.625 17.8512 16.0388 18.4375 15.3125 18.4375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.6aa92b820c182c1c68565234f7cdfa0b.svg";
export { ForwardRef as ReactComponent };